import { AxiosResponse } from 'axios'
import {useQuery, UseQueryOptions, useMutation, UseQueryResult} from 'react-query'
import { APIEndpoints } from '../constants/api-endpoints'
import { QueryKeys }     from './_query_keys'
import { HttpRequest }  from '../services/_http'

export const useGetTemplatesData = (searchOptions?:any, options?: UseQueryOptions): UseQueryResult <any> => {
    const method   = 'GET'
    const queryKey = [QueryKeys.TEMPLATES,searchOptions]

    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: `${APIEndpoints.Templates}`,
            params: searchOptions,
            method
        }),
        refetchOnWindowFocus:false,
        cacheTime: 0,
        ...options
    })
}

export const useGetTemplateById = (id: string | number | undefined, options?: any) => {
    return useQuery(
        ['template-by-id', id],
        () =>
            HttpRequest({
                url: `${APIEndpoints.Templates}/${id}`,
                method: 'GET',
            }),
        {
            enabled: !!id,
            ...options,
        }
    )
}

export const useAddTemplates = (options?: any) => {

    const method = 'POST'
    return useMutation(({data}: {data: any})=> HttpRequest({
        url: `${APIEndpoints.Templates}`,
        method,
        data
    }), options)
}

export const useUpdateTemplateData = (options?: any) => {
    const method = 'PUT'
    return useMutation(({ data, id }: { data: any, id: any }) => HttpRequest({
        url: `${APIEndpoints.Templates}/${id}`,
        method,
        data
    }), options)
}

export const useStatusTemplates = (options?: any) => {
    const method = 'PATCH'
    return useMutation(({data, id}: {data: FormData, id: any})=> HttpRequest({
        url: `${APIEndpoints.Templates}/${id}/status`,
        method,
        data
    }), options)
}

export const useDeleteTemplate = (options?: any) => {
    const method = 'DELETE'
    return useMutation(({id}: {id: any})=> HttpRequest({
        url: `${APIEndpoints.Templates}/${id}`,
        method,
    }), options)
}


// hooks/templates.ts

export const useSetDefaultTemplate = (options?: any) => {

    const method = 'POST'

    return useMutation(
        ({ data }: { data: { template_id: string } }) =>
            HttpRequest({
                url: `${APIEndpoints.Templates}/default`,
                method,
                data,
            }),
        options
    )
}



